exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ant-tabs-nav .ant-tabs-ink-bar {\n  background-color: #00c6d7;\n  height: 4px; }\n\n.ant-tabs-nav .ant-tabs-tab {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  color: #5d6368;\n  padding-bottom: 20px; }\n  .ant-tabs-nav .ant-tabs-tab:hover {\n    color: #5d6368; }\n\n.ant-tabs-nav .ant-tabs-tab-active {\n  font-weight: 700;\n  color: #5d6368; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Tabs/style.scss
// module id = 1045
// module chunks = 0